import React from "react";

const CenterWrapper = ({ children }) => {
  return (
    <div className="w-full py-6 sm:py-12 px-6 sm:px-12 flex flex-col max-w-7xl m-auto">
      {children}
    </div>
  );
};

export default CenterWrapper;
